import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, inject, Inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Bewegung } from '../../data/bewegung';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { Store } from '@softline/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ArbeitsscheinConfig, SOFTLINE_CONFIG_ARBEITSSCHEIN } from "../../arbeitsschein.config";

import { NumberInputComponent } from '@softline/ui-core';
import { ReplacePipe } from '@softline/ui-core';
import { SecureHtmlPipe } from '@softline/ui-core';
@Component({
    selector: 'lib-work-note-item-card',
    templateUrl: './work-note-item-card.component.html',
    styleUrls: ['./work-note-item-card.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ReactiveFormsModule,
    NumberInputComponent,
    ReplacePipe,
    SecureHtmlPipe],
    providers: [DecimalPipe]
})
export class WorkNoteItemCardComponent implements OnInit, OnDestroy {
  // tslint:disable-next-line:variable-name
  private _bewegung?: Bewegung;

  // tslint:disable-next-line:variable-name
  private _readonly = false;

  private subscription?: Subscription;

  private readonly numberPipe = inject(DecimalPipe);

  @Output() readonly editNoteTapped = new EventEmitter<null>();
  @Output() readonly doneQuantityChange = new EventEmitter<number>();
  @Output() readonly copyTapped = new EventEmitter<Bewegung>();

  @Input()
  get readonly(): boolean {
    return this._readonly;
  }
  set readonly(value: boolean) {
    this._readonly = value;

    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input()
  get bewegung(): Bewegung | undefined {
    return this._bewegung;
  }
  set bewegung(value: Bewegung | undefined) {
    this._bewegung = value;

    console.log('value: ', value);
    const formattedValue = (value?.mengeErl + '')?.replace('.', ',');
    this.form.patchValue({ mengeErl: formattedValue }, { emitEvent: false });
  }

  @Input() noteEditable = false

  readonly form = this.fb.group({
    mengeErl: [] }, { updateOn: 'blur' });

  constructor(private fb: UntypedFormBuilder,
              private store: Store,
              @Inject(SOFTLINE_CONFIG_ARBEITSSCHEIN) public config: ArbeitsscheinConfig) {}

  ngOnInit(): void {
    this.subscription = this.form.controls['mengeErl'].valueChanges.subscribe(
      (value) => {
        if (value === undefined || value === null) {
          this.doneQuantityChange.emit(undefined);
          return;
        }

        const formattedValue = value?.replace(',', '.');

        if (isNaN(+formattedValue)) {
          this.form.patchValue({ mengeErl: undefined }, { emitEvent: false });
          this.store.dispatch(
            SOFTLINE_FEATURE_MESSAGE_BAR,
            MessageBarStore.actions.error,
            { title: '#WORK_NOTE.MESSAGES.ONLY_NUMERIC' }
          );
          return;
        } else {
          this.doneQuantityChange.emit(+formattedValue);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();

    this.subscription = undefined;
  }

  protected readonly isNaN = isNaN;
}
